module.exports = __webpack_public_path__ + "static/media/gallery_2_5.9e397d37.jpg";